import Component from '@glimmer/component';
import type UiInputGroupNativeSelectOptionComponent from './native-select/option';

interface UiInputGroupNativeSelectSignature {
  Element: HTMLSelectElement;
  Args: {
    Named: {
      id: string;
      ariaDescribedby?: string;
    };
  };
  Blocks: {
    default: [
      {
        Option: typeof UiInputGroupNativeSelectOptionComponent;
      }
    ];
  };
}

export default class UiInputGroupNativeSelectComponent extends Component<UiInputGroupNativeSelectSignature> {
  closeOnEscape(event: KeyboardEvent) {
    if (event.key !== 'Escape') return;

    if (event.target instanceof HTMLElement) {
      event.preventDefault();
      event.stopPropagation();

      // Close the native select when pressing escape
      // and avoid propagation to the modal
      event.target.blur();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::InputGroup::NativeSelect': typeof UiInputGroupNativeSelectComponent;
    'ui/input-group/native-select': typeof UiInputGroupNativeSelectComponent;
  }
}
